










































import Vue from 'vue'
import rangeInstance from '@/common/rangeSliderInstance'
import NumberInput from '@/common/components/NumberInput.vue'

export default Vue.extend({
  name: 'RangeSlider',
  components: {
    NumberInput
  },
  props: {
    minThreshold: {
      type: Number,
      default: 0
    },
    maxThreshold: {
      type: Number,
      default: 0
    },
    minRange: {
      type: Number,
      required: true
    },
    maxRange: {
      type: Number,
      required: true
    },
    resetRange: {
      type: Boolean,
      required: false,
      default: false
    },
    rangeElementId: {
      type: String,
      default: 'rangeSlider'
    }
  },
  data(): {
    rangeInst: any
    setMinRange: number
    setMaxRange: number
    minRangeInput: number
    maxRangeInput: number
    minKey: number
    maxKey: number
  } {
    return {
      rangeInst: undefined,
      setMinRange: this.minRange,
      setMaxRange: this.maxRange,
      minRangeInput: this.minRange,
      maxRangeInput: this.maxRange,
      minKey: 0,
      maxKey: 1000
    }
  },
  computed: {
    stepRange(): number {
      return (this.maxThreshold - this.minThreshold) / 100
    },
    invalidRange(): boolean {
      return (
        this.setMinRange > this.setMaxRange ||
        this.setMaxRange < this.setMinRange ||
        this.setMinRange < this.minThreshold ||
        this.setMaxRange > this.maxThreshold
      )
    },
    minRangeValidate(): boolean {
      return this.setMinRange == 0
    },
    maxRangeValidate(): boolean {
      return this.setMaxRange == 0
    },
    minRangeValue(): number {
      return (
        this.setMinRange !== 0 ? this.setMinRange : this.minThreshold
      )
    },
    maxRangeValue(): number {
      return (
        this.setMaxRange !== 0 ? this.setMaxRange : this.maxThreshold
      )
    }
  },
  watch: {
    resetRange(value: boolean) {
      if (value) {
        this.rangeInst.reset()
        this.updateRangeValues(this.minThreshold, this.maxThreshold)
      }
    },
    minRangeValidate(value: boolean) {
      this.$emit('onUpdateMinValidate', value)
    },
    maxRangeValidate(value: boolean) {
      this.$emit('onUpdateMaxValidate', value)
    }
  },
  mounted() {
    this.rangeInst = new rangeInstance(this.rangeElementId)
    this.rangeInst.onChange = (min: number, max: number) =>
      this.updateRangeValues(min, max)
    this.rangeInst.didChanged = (min: number, max: number) =>
      this.updatedRangeValues(min, max)
  },
  methods: {
    onChangeMinRange(min: number) {
      this.rangeInst.setMinValue(min)
      this.rangeInst.setMaxValue(this.maxRangeValue)
      this.updatedRangeValues(this.setMinRange, this.setMaxRange)
    },
    onChangeMaxRange(max: number) {
      this.rangeInst.setMaxValue(max)
      this.updatedRangeValues(this.setMinRange, this.setMaxRange)
    },
    updateRangeValues(min: number, max: number) {
      this.setMinRange = min
      this.setMaxRange = max
    },
    updatedRangeValues(min: number, max: number) {
      this.setMinRange = min
      this.setMaxRange = max
      this.$emit('onUpdatedRangeValues', { min: this.minRangeValue, max: this.maxRangeValue })
    },
    updateRangeMinValues(value: number) {
      const temp = this.setMinRange
      this.setMinRange = value
      if (value) {
        if (this.setMinRange < this.minThreshold) {
          this.setMinRange = this.minThreshold
        }
        if (this.setMinRange > this.setMaxRange && this.setMaxRange) {
          this.setMinRange = this.setMaxRange
        }
        this.onChangeMinRange(this.setMinRange)
      }
      else {
        this.onChangeMinRange(1)
      }
      if (temp===this.setMinRange) this.minKey=this.minKey+1

    },
    updateRangeMaxValues(value: number) {
      const temp = this.setMaxRange
      this.setMaxRange = value
      if (value) {
        if (this.setMaxRange > this.maxThreshold) {
        this.setMaxRange = this.maxThreshold
        }
        const maxValue = this.setMaxRange < this.setMinRange || this.setMaxRange < this.minThreshold ? this.setMinRange:  this.setMaxRange
        this.onChangeMaxRange(maxValue)
      }
      else {
        this.onChangeMaxRange(this.maxThreshold)
      }
      if (temp===this.setMaxRange) this.maxKey=this.maxKey+1
    }
  }
})
